const DASHBOARD_QUICKVIEW_CLOSE = 'DASHBOARD_QUICKVIEW_CLOSE'

const dashboardQuickviewClose = () => {
  return {
    type: DASHBOARD_QUICKVIEW_CLOSE
  }
}

export { DASHBOARD_QUICKVIEW_CLOSE, dashboardQuickviewClose }
